module.exports = __webpack_public_path__ + "img/DF_plus_grey.e21cf899.svg";